/* BeatBot theme: synth grid hero + scope waveforms.
   Colours: a 2-colour gradient (c1 -> c2 -> c1). In "cycle" mode the pair slowly moves through
   the colours in time with the RGB outline; in "fixed" mode it stays on the two theme colours. */
(function () {
  'use strict';
  var body = document.body;
  var MODE = body.getAttribute('data-glow') || 'cycle';
  var SPEED = (parseFloat(body.getAttribute('data-speed')) || 14) * 1000;
  var FIX1 = hexRgb(body.getAttribute('data-c1') || '#2f6bff');
  var FIX2 = hexRgb(body.getAttribute('data-c2') || '#ff2d3d');
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DPR = Math.min(window.devicePixelRatio || 1, 2);

  function hexRgb(h) {
    h = h.replace('#', '');
    if (h.length === 3) h = h.replace(/./g, '$&$&');
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function hsv(hh) { // same colours as the app (s .85, v 1)
    hh = ((hh % 1) + 1) % 1 * 6;
    var s = .85, i = Math.floor(hh), f = hh - i, p = 1 - s, q = 1 - s * f, t = 1 - s * (1 - f);
    var c = [[1, t, p], [q, 1, p], [p, 1, t], [p, q, 1], [t, p, 1], [1, p, q]][i % 6];
    return [c[0] * 255 | 0, c[1] * 255 | 0, c[2] * 255 | 0];
  }
  function css(c, a) { return 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (a == null ? 1 : a) + ')'; }
  var _bg = null;
  function bgRgb() {     // the hero's own background colour (follows the theme colours)
    if (_bg) return _bg;
    var m = (getComputedStyle(hero).backgroundColor || '').match(/\d+/g);
    return (_bg = m ? [+m[0], +m[1], +m[2]] : [34, 34, 35]);
  }
  function now() { return (document.timeline && document.timeline.currentTime) || performance.now(); }
  // the current colour pair
  function pair() {
    if (MODE === 'fixed') return [FIX1, FIX2];
    var h = now() / SPEED;            // in step with the CSS outline cycle
    return [hsv(h), hsv(h + 0.38)];   // e.g. red + blue, drifting together
  }
  function grad(ctx, x0, x1, c) {
    var g = ctx.createLinearGradient(x0, 0, x1, 0);
    g.addColorStop(0, css(c[0])); g.addColorStop(.5, css(c[1])); g.addColorStop(1, css(c[0]));
    return g;
  }
  function size(cv) {
    var w = cv.clientWidth, h = cv.clientHeight;
    if (!w || !h) return null;
    if (cv.width !== Math.round(w * DPR) || cv.height !== Math.round(h * DPR)) {
      cv.width = Math.round(w * DPR); cv.height = Math.round(h * DPR);
    }
    var x = cv.getContext('2d'); x.setTransform(DPR, 0, 0, DPR, 0, 0);
    return { x: x, w: w, h: h };
  }

  /* ---------- audio data (from the player in theme.js) ---------- */
  var freq = null, time = null;
  function audioData() {
    var an = window.BeatBot && window.BeatBot.analyser();
    if (!an) return null;
    if (!freq || freq.length !== an.frequencyBinCount) { freq = new Uint8Array(an.frequencyBinCount); time = new Uint8Array(an.fftSize); }
    an.getByteFrequencyData(freq); an.getByteTimeDomainData(time);
    return an;
  }
  // 48 log-spaced bands, mirrored -> 96 points for the ridge
  var BANDS = 48, ridge = new Float32Array(BANDS * 2), idle = new Float32Array(BANDS * 2);
  function bands(an) {
    var sr = an.context.sampleRate, n = freq.length, out = new Float32Array(BANDS);
    for (var b = 0; b < BANDS; b++) {
      var lo = 35 * Math.pow(16000 / 35, b / BANDS), hi = 35 * Math.pow(16000 / 35, (b + 1) / BANDS);
      var i0 = Math.max(1, Math.floor(lo / (sr / 2) * n)), i1 = Math.max(i0 + 1, Math.ceil(hi / (sr / 2) * n)), m = 0;
      for (var i = i0; i < i1 && i < n; i++) if (freq[i] > m) m = freq[i];
      out[b] = Math.min(1, 0.04 + Math.pow(m / 255, 1.5) * (0.7 + b / BANDS * 0.9));
    }
    return out;
  }

  /* ---------- synth grid hero ---------- */
  var hero = document.querySelector('[data-synth]');
  var heroCv = hero && hero.querySelector('[data-synth-canvas]');
  var nowEl = hero && hero.querySelector('[data-synth-now]');
  var amp = hero ? (parseFloat(hero.getAttribute('data-height')) || 100) / 100 : 1;

  function drawHero(t, an) {
    var s = size(heroCv); if (!s) return;
    var x = s.x, w = s.w, h = s.h, c = pair(), hz = h * 0.56;
    x.clearRect(0, 0, w, h);

    // floor grid: lines to the vanishing point + rows that scroll towards you
    var g = grad(x, 0, w, c);
    x.lineWidth = 1; x.strokeStyle = g;
    x.globalAlpha = .32;
    for (var i = -34; i <= 34; i++) { x.beginPath(); x.moveTo(w / 2 + i * 9, hz); x.lineTo(w / 2 + i * (w / 11), h); x.stroke(); }
    var scroll = still ? 0 : (t / 1400) % 1;
    for (var k = 0; k < 16; k++) {
      var f = (k + scroll) / 16, y = hz + Math.pow(f, 2.3) * (h - hz);
      x.globalAlpha = .1 + f * .45; x.beginPath(); x.moveTo(0, y); x.lineTo(w, y); x.stroke();
    }
    x.globalAlpha = 1;

    // the ridge: live spectrum while a beat plays, a slow drift when idle
    var target = idle;
    for (var j = 0; j < BANDS; j++) {
      var v = 0.12 + 0.08 * Math.sin(t / 900 + j * 0.45) + 0.06 * Math.sin(t / 1700 - j * 0.9) + 0.05 * Math.sin(j * 1.7);
      idle[j] = idle[BANDS * 2 - 1 - j] = still ? 0.15 : Math.max(0.03, v);
    }
    if (an) {
      var bb = bands(an), lv = new Float32Array(BANDS * 2);
      for (var q = 0; q < BANDS; q++) lv[q] = lv[BANDS * 2 - 1 - q] = bb[BANDS - 1 - q];   // bass in the middle, highs at the edges
      target = lv;
    }
    for (var r = 0; r < ridge.length; r++) ridge[r] += (target[r] - ridge[r]) * (an ? 0.5 : 0.08);

    var H = Math.min(190, h * 0.36) * amp, n = ridge.length;
    x.lineWidth = 2.5; x.strokeStyle = g; x.shadowColor = css(c[1], .9); x.shadowBlur = 16;
    x.beginPath();
    for (var p = 0; p < n; p++) { var px = p / (n - 1) * w, py = hz - ridge[p] * H; p ? x.lineTo(px, py) : x.moveTo(px, py); }
    x.stroke();
    x.shadowBlur = 0; x.globalAlpha = .22; x.beginPath();
    for (var p2 = 0; p2 < n; p2++) { var px2 = p2 / (n - 1) * w, py2 = hz + ridge[p2] * H * .4; p2 ? x.lineTo(px2, py2) : x.moveTo(px2, py2); }
    x.stroke(); x.globalAlpha = 1;

    // darken behind the text so it stays readable
    var fg = x.createLinearGradient(0, 0, w, 0);
    var bg = bgRgb();
    fg.addColorStop(0, css(bg, .78)); fg.addColorStop(.45, css(bg, .35)); fg.addColorStop(.8, css(bg, 0));
    x.fillStyle = fg; x.fillRect(0, 0, w, h);
  }

  /* ---------- scope lines on every beat ---------- */
  function seeded(seed, n) {
    var s = 0; seed = String(seed);
    for (var i = 0; i < seed.length; i++) s = (s * 31 + seed.charCodeAt(i)) >>> 0;
    function rnd() { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }
    var out = [], intro = 0.1 + rnd() * 0.1, outro = 0.9 + rnd() * 0.05;
    for (var k = 0; k < n; k++) {
      var f = k / n, env = f < intro ? 0.35 : f > outro ? 0.3 : 0.85;
      out.push(Math.min(1, env * (0.7 + rnd() * 0.3)));
    }
    return out;
  }
  function waveOf(cv) {
    if (cv._wave) return cv._wave;
    var w = null;
    try { w = JSON.parse(cv.getAttribute('data-wave') || 'null'); } catch (e) {}
    if (!Array.isArray(w) || w.length < 8) w = seeded(cv.getAttribute('data-seed') || 'x', 110);
    return (cv._wave = w);
  }
  function drawScope(cv, live, t) {
    var s = size(cv); if (!s) return;
    var x = s.x, w = s.w, h = s.h;
    x.clearRect(0, 0, w, h);
    var c = pair();
    if (live && time) {             // real oscilloscope of what's playing
      x.lineWidth = 1.6; x.strokeStyle = grad(x, 0, w, c); x.shadowColor = css(c[1], .8); x.shadowBlur = 6;
      x.beginPath();
      var n = 256, step = Math.floor(time.length / n);
      for (var i = 0; i < n; i++) { var v = (time[i * step] - 128) / 128, px = i / (n - 1) * w, py = h / 2 + v * h * 0.9; i ? x.lineTo(px, py) : x.moveTo(px, py); }
      x.stroke(); x.shadowBlur = 0; return;
    }
    var d = waveOf(cv), m = d.length, on = !!live;
    x.lineWidth = on ? 1.6 : 1.1;
    x.strokeStyle = on ? grad(x, 0, w, c) : 'rgba(140,140,141,.55)';
    if (on) { x.shadowColor = css(c[1], .8); x.shadowBlur = 6; }
    x.beginPath();
    var wob = on && !still ? t / 120 : 0;
    for (var k = 0; k < m; k++) {
      var amp2 = d[k] * (on ? 0.85 + 0.15 * Math.sin(wob + k) : 1);
      var px3 = k / (m - 1) * w, py3 = h / 2 + (k % 2 ? 1 : -1) * amp2 * h * 0.45;
      k ? x.lineTo(px3, py3) : x.moveTo(px3, py3);
    }
    x.stroke(); x.shadowBlur = 0;
  }

  var scopes = [].slice.call(document.querySelectorAll('[data-scope]'));
  var playerScope = document.querySelector('[data-player-scope]');
  function drawAllStatic() { scopes.forEach(function (cv) { drawScope(cv, false, 0); }); }

  /* ---------- loop ---------- */
  var lastSrc = null, lastW = 0, lastTitle = null;
  function frame(t) {
    var src = window.BeatBot && window.BeatBot.playing();
    var an = src ? audioData() : null;
    if (!an) time = null;
    if (hero && heroCv && isVisible(hero)) drawHero(t, an);
    // re-draw the idle scopes only when something changed (cheap), the playing one every frame
    if (src !== lastSrc || window.innerWidth !== lastW) { drawAllStatic(); lastSrc = src; lastW = window.innerWidth; }
    if (src) scopes.forEach(function (cv) {
      var row = cv.closest('[data-beat]');
      if (row && row.getAttribute('data-src') === src && isVisible(cv)) drawScope(cv, true, t);
    });
    if (playerScope && !playerScope.closest('[hidden]')) drawScope(playerScope, !!src, t);
    if (nowEl) {
      var title = src ? (document.querySelector('[data-p-title]') || {}).textContent || '' : '';
      if (title !== lastTitle) {
        lastTitle = title;
        nowEl.textContent = title ? 'NOW PLAYING \u00b7 ' + title : '';
      }
    }
    requestAnimationFrame(frame);
  }
  function isVisible(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
  }
  if (still) { if (hero && heroCv) drawHero(0, null); drawAllStatic(); }
  requestAnimationFrame(frame);
})();
